import { Vector2, Vector3 } from 'three';

import { getNormalAxis } from './getNormalAxis.js';

/**
 * Project a 3D point onto a 2D plane defined by a normal vector.
 * @param point - The 3D point.
 * @param normal - The normal vector of the plane.
 * @returns The projected 2D point.
 */
export const projectPointToAxis = (point: Vector3, normal: Vector3) => {
  const axis = getNormalAxis(normal);

  switch (axis) {
    case 'x':
      return new Vector2(point.y, point.z);
    case 'y':
      return new Vector2(point.x, point.z);
    case 'z':
      return new Vector2(point.x, point.y);
  }
};
